import React, { ReactElement } from 'react';
import styled from 'styled-components';

import { BadgeItem } from 'features/badges';
import { Row, Col, Section, Flex, Typography, ButtonIcon } from 'components';

interface BadgesListProps {
  badges: BadgeItem[];
}

const BadgeImage = styled('img')`
  display: block;
  width: 75px;
  height: 75px;
  background: lightgray;
  border-radius: 50%;
`;

const BadgeDescription = styled(Flex)`
  display: none;

  &::before {
    content: '';
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 4px solid ${({ theme }) => theme.colors.dark_350};
    position: absolute;
    top: -4px;
    right: 19px;
  }
`;

const ButtonWrapper = styled(Flex)`
  &:hover {
    ${BadgeDescription} {
      display: flex;
    }
  }
`;

const BadgesList = ({ badges }: BadgesListProps): ReactElement => (
  <Section>
    <Row gutter={15} mt={{ d: 20 }}>
      {badges.map((badge) => (
        <Col width={{ m: 1 / 2, t: 1 / 4, d: 1 / 6 }}>
          <ButtonWrapper title={badge.name} bg="white" mt={15} p={15} flexDirection="column" borderRadius={4} position="relative">
            <BadgeImage src={badge.imageUrl} />

            <ButtonIcon icon="info" bg="transparent" color="primary_400" position="absolute" top={15} right={15} />

            <BadgeDescription position="absolute" width={1} top={40} left={0} bg="dark_350" p={15} borderRadius={4} flexDirection="column">
              <Typography type="type1" color="white" fontWeight="bold" upper>
                Como Ganhar
              </Typography>

              <Typography type="type1" color="gray_300" mt={2} lineHeight="1.3">
                {badge.howToEarn}
              </Typography>
            </BadgeDescription>

            <Typography type="type3" fontWeight="bold" mt={3} lineHeight="1.3">
              {badge.name}
            </Typography>
          </ButtonWrapper>
        </Col>
      ))}
    </Row>
  </Section>
);

export default BadgesList;
